import { render, staticRenderFns } from "./ExperienceHomeNew.vue?vue&type=template&id=2d54d3f1&scoped=true&"
import script from "./ExperienceHomeNew.vue?vue&type=script&lang=js&"
export * from "./ExperienceHomeNew.vue?vue&type=script&lang=js&"
import style1 from "./ExperienceHomeNew.vue?vue&type=style&index=1&id=2d54d3f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d54d3f1",
  null
  
)

export default component.exports